module.exports = __webpack_public_path__ + "src/routes/home/footBanner.png?b6ac4103";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/footBanner.png
// module id = 2851
// module chunks = 1